/** Seconds left as the ring clock shows them: whole seconds, rounded up, as m:ss. */
export function formatClock(seconds: number): string {
  const whole = Math.max(0, Math.ceil(seconds - 1e-9));
  return `${Math.floor(whole / 60)}:${String(whole % 60).padStart(2, '0')}`;
}
